import '../scss/main.scss';
import Header from "@components/Header";
import Loader from "@components/Loader.js";
import Woami from "@js/animations/Woami.js";
import {gsap} from "gsap";
import MailCopy from "@abstracts/MailCopy.js";
import TransitionLine from "@js/animations/TransitionLine.js";
import Animations from "@js/animations/Animations.js";
import Workflow from "@js/animations/Workflow.js";
import ProjectsSlider from "@js/animations/ProjectsSlider.js";
import ReviewsSlider from "@js/animations/ReviewsSlider.js";
import ProcessHero from "@js/animations/ProcessHero.js";
import ProcessTimeline from "@js/animations/ProcessTimeline.js";
import AboutSection from "@js/animations/AboutSection.js";
import SideNavigation from "@js/animations/SideNavigation.js";


window.addEventListener('beforeunload', () => {

    window.scrollTo(0, 0);
});

if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
}
window.scrollTo(0, 0);


class App {
    constructor() {
        this.init();
    }

    init() {
        const debug = false;
        if(debug === true) {
            document.querySelector('html').classList.remove('no-scroll');
            document.getElementById("loader").remove();
            this.initComponents();
        } else {
            new Loader();

            document.addEventListener("loader:finished", () => {
                this.initComponents();
            });
        }
        new MailCopy();
    }

    initComponents = () => {
        new Header();
        new Animations();
        new ProcessHero();
        new ProcessTimeline();
        new SideNavigation();

        if (document.querySelector('.woami')) {
            new Woami();
        }

        if (document.querySelector('.transitionLine')) {
            new TransitionLine();
        }

        if (document.querySelector('.workflow')) {
            new Workflow();
        }

        if (document.querySelector('.projects')) {
            new ProjectsSlider();
        }

        if (document.querySelector('.reviews')) {
            new ReviewsSlider();
        }

        if (document.querySelector('.about-section')) {
            new AboutSection();
        }
    }
}

// Initialize app when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    window.scrollTo(0, 0);
    new App();
});

// Handle visibility change (pause animations when tab is not visible)
document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
        gsap.ticker.sleep();
    } else {
        gsap.ticker.wake();
    }
});